module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/page-up-997d9ba86808643d70e20dae5731a485.svg";